import * as yup from "yup";

export const BulkKeywordUpdateSchema = yup.object().shape({
  type: yup.string().trim().required("Required"),
  key: yup.string().trim().required("Required"),
  keyword: yup.string().trim().required("Required"),
});
